export var VerdantErrorCode;
(function (VerdantErrorCode) {
    VerdantErrorCode[VerdantErrorCode["InvalidRequest"] = 4000] = "InvalidRequest";
    VerdantErrorCode[VerdantErrorCode["BodyRequired"] = 4001] = "BodyRequired";
    VerdantErrorCode[VerdantErrorCode["NoToken"] = 4010] = "NoToken";
    VerdantErrorCode[VerdantErrorCode["InvalidToken"] = 4011] = "InvalidToken";
    VerdantErrorCode[VerdantErrorCode["TokenExpired"] = 4012] = "TokenExpired";
    VerdantErrorCode[VerdantErrorCode["Forbidden"] = 4030] = "Forbidden";
    VerdantErrorCode[VerdantErrorCode["NotFound"] = 4040] = "NotFound";
    VerdantErrorCode[VerdantErrorCode["Unexpected"] = 5000] = "Unexpected";
    VerdantErrorCode[VerdantErrorCode["ConfigurationError"] = 5010] = "ConfigurationError";
    VerdantErrorCode[VerdantErrorCode["NoFileStorage"] = 5011] = "NoFileStorage";
})(VerdantErrorCode || (VerdantErrorCode = {}));
export class VerdantError extends Error {
    constructor(code, cause, message) {
        super(message !== null && message !== void 0 ? message : `Verdant error: ${code}`, {
            cause,
        });
        this.code = code;
        this.toResponse = () => {
            return JSON.stringify({
                code: this.code,
            });
        };
    }
    get httpStatus() {
        const status = Math.floor(this.code / 10);
        if (status < 600) {
            return status;
        }
        return 500;
    }
}
VerdantError.Code = VerdantErrorCode;
export function isVerdantErrorResponse(body) {
    return (typeof body === 'object' && 'code' in body && typeof body.code === 'number');
}
//# sourceMappingURL=error.js.map